import { render, staticRenderFns } from "./LoanSize.vue?vue&type=template&id=16db1c4e&"
import script from "./LoanSize.vue?vue&type=script&lang=js&"
export * from "./LoanSize.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports